import { performDeleteRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import { type Ari, getAriConfig } from '@atlassian/jira-platform-ari/src/index.tsx';

export const deletePlay = (playId: Ari): Promise<void> => {
	// extract the playResourceId from the Ari
	const { resourceId } = getAriConfig(playId);

	return performDeleteRequest(`/gateway/api/polaris/rest/plays/${resourceId}`);
};
